import React from "react";
import { type SpaceProps, Table, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import { getTransparentBrandColorHex } from "theme/colors";
import { tableData } from "./data";

const bgColor = getTransparentBrandColorHex("violet", 150, 0.5);
const cellPx: SpaceProps["px"] = { base: "small", lg: "bigger" };

export function ComparisonsTable() {
  return (
    <Table variant="unstyled" maxW="container.section" mx="auto">
      <Thead>
        <Tr>
          <Th scope="col" pl={cellPx} aria-label="Row headers" />
          {tableData.head.map((head) => (
            <Th
              key={head}
              scope="col"
              py="big"
              px={cellPx}
              width="27%"
              _last={{
                bg: bgColor,
                borderTopRadius: "bigger",
              }}
            >
              <Text
                as="span"
                textStyle="headline3"
                fontSize={{ base: "brand.sm", lg: "brand.md", xl: "brand.lg" }}
                textTransform="none"
              >
                {head}
              </Text>
            </Th>
          ))}
        </Tr>
      </Thead>

      <Tbody>
        {tableData.rows.map(({ rowHead, rowData }, index) => (
          <Tr key={rowHead} textStyle="caption1" borderTop="1px" borderColor="brand.border.extraLight">
            <Th scope="row" fontWeight="bold" py="bigger">
              <Text as="span" textStyle="caption1" textTransform="none">
                {rowHead}
              </Text>
            </Th>
            {rowData.map((row) => {
              const isLasRow = index === tableData.rows.length - 1;
              return (
                <Td
                  key={row}
                  py="bigger"
                  px={cellPx}
                  width="27%"
                  verticalAlign="top"
                  borderBottomRadius={isLasRow ? "bigger" : undefined}
                  _last={{
                    bg: bgColor,
                  }}
                >
                  {row}
                </Td>
              );
            })}
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
}
